@if (trail$ | async; as trail) {
  @if (trail.items.length > 0) {
    <nav
      class="pt-12 md:pt-[4.5rem] pb-2 breadcrumb-container"
      aria-label="Breadcrumb"
      >
      @if (trail.complete) {
        <!-- BLA-54: complete SEO trail (Home first). Wraps on narrow screens; nothing is truncated. -->
        <ol
          class="flex flex-wrap items-center gap-x-1 gap-y-1 m-0 py-2 px-2 md:px-0 text-[13px] w-full md:w-fit max-w-full pointer-events-auto font-apple"
          >
          @for (c of trail.items; track c.url; let first = $first, last = $last) {
            @if (!first) {
              <li class="text-white/40 font-light flex items-center" aria-hidden="true">/</li>
            }
            <li class="crumb flex items-center min-w-0 [overflow-wrap:anywhere]" [class.home]="first" [class.current]="last">
              @if (!last) {
                <a
                  [routerLink]="c.url"
                  class="inline-flex items-center min-h-6 text-white/80 no-underline font-medium transition-colors duration-150 hover:text-white hover:underline"
                  >{{ c.label }}</a
                  >
              } @else {
                <span class="text-white/60" aria-current="page">{{ c.label }}</span>
              }
            </li>
          }
        </ol>
      } @else {
        <ol
          class="flex items-center gap-1 m-0 py-2 px-2 md:px-0 text-[13px] w-full md:w-fit max-w-full pointer-events-auto font-apple overflow-hidden"
          >
          <li class="crumb home flex items-center flex-shrink-0">
            <a
              routerLink="/"
              class="text-white/80 no-underline font-medium transition-colors duration-150 hover:text-white hover:underline flex items-center"
              >Home</a
              >
          </li>
          @for (c of trail.items; track c; let last = $last) {
            <li
              class="text-white/40 font-light flex items-center flex-shrink-0"
              aria-hidden="true"
              >
              /
            </li>
            <li class="crumb flex items-center min-w-0" [class.current]="last">
              @if (!last) {
                <a
                  [routerLink]="c.url"
                  class="text-white/80 no-underline font-medium transition-colors duration-150 hover:text-white hover:underline block whitespace-nowrap overflow-hidden text-ellipsis min-w-0 max-w-[15ch] md:max-w-none"
                  [title]="c.label"
                  >{{ c.label }}</a
                  >
              }
              @if (last) {
                <span
                  class="text-white/60 whitespace-nowrap overflow-hidden text-ellipsis block min-w-0 flex-1 max-w-[20ch] md:max-w-none"
                  [title]="c.label"
                  aria-current="page"
                  >{{ c.label }}</span
                  >
              }
            </li>
          }
        </ol>
      }
    </nav>
  }
}
